import Tabs from '@/components/Tabs/Tabs';
import './Generate.less';
import { useEffect, useState } from 'react';
import uploadIcon from '@/assets/home/upload.png';
import { Upload } from 'antd';
import { useNavigate } from 'react-router-dom';
import { SDService } from '@/api';
import GenerateProgress from '@/components/GenerateProgress/GenerateProgress';
import { getInpaintMaskImage } from '@/utils/unityTool';

export default function Generate(props) {
  const [images, setImages] = useState(props.images);

  const [list, setList] = useState(props.single ? [{}] : [{}, {}, {}, {}]);
  const [chooseImage, setChooseImage] = useState(null);

  useEffect(() => {
    setImages(props.images);
    dealImage();
  }, [props.images]);

  // 处理图片
  const dealImage = async () => {
    if (props.single && props.images) {
      const res = await getInpaintMaskImage(props.sendMessage, props.images[0]);
      const image = {
        data: res,
        finished: true,
      };
      setImages([image]);

      document.getElementById('renderImage').src = res;
      props.onChooseImage(image);
    } else if (props.images) {
      setImages(props.images.map((item) => ({ data: item, finished: true })));
    }
  };

  return (
    <div className={'generate-pop ' + (props.single && 'single-pop')}>
      {props.single ? (
        <div className="generate-loading"></div>
      ) : (
        <div className={'generate-wrapper ' + props.className + ' ' + (props.single && 'single')}>
          {images
            ? images.map((item, i) => {
                return (
                  <div
                    onClick={() => {
                      setChooseImage(item);
                    }}
                    key={i}
                    className={'image ' + (chooseImage === item ? 'selected' : '')}>
                    {item.finished ? <img src={item.data}></img> : <></>}
                    {chooseImage === item && (
                      <div
                        onClick={() => {
                          props.onChooseImage(item);
                        }}
                        className="continue">
                        Continue
                      </div>
                    )}
                  </div>
                );
              })
            : list.map((item, i) => {
                return <GenerateProgress key={i} percent={props.progress}></GenerateProgress>;
              })}
          <div
            className="close"
            onClick={() => {
              props.onClose();
            }}></div>
        </div>
      )}
    </div>
  );
}
